export default __webpack_public_path__ + "static/media/info.c35a612f.svg";